var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckForPrizes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 99,
    viewBox: "0 0 108 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7593,
    cy: 53.585,
    r: 44.7593,
    fill: "#28293F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5186,
    cy: 41.6071,
    r: 17.6516,
    fill: "#FFBC00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6083,
    cy: 83.2145,
    r: 6.30413,
    fill: "#3C37FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8132 55.1832C40.7497 51.6612 41.9906 46.2409 41.9906 40.1616C41.9906 39.5999 41.9802 39.0444 41.9595 38.4951H47.561C47.5408 39.0444 47.5304 39.5999 47.5299 40.1616C47.5299 46.2409 48.7708 51.6612 50.7073 55.1832H38.8132Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5327 40.1616C47.5327 39.5999 47.5431 39.0444 47.5638 38.4951H41.9622C41.9825 39.0444 41.9928 39.5999 41.9934 40.1616C41.9934 41.2453 41.9529 42.3081 41.8774 43.3428C41.8774 43.3428 44.574 41.6927 47.6517 43.3428C47.5724 42.3081 47.5327 41.2453 47.5327 40.1616Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3566 38.4951H42.5513C42.5674 39.0444 42.5757 39.5999 42.5762 40.1616C42.5762 46.2409 41.5975 51.6612 40.0703 55.1832H41.7819C42.7521 51.6612 43.3745 46.2409 43.3745 40.1616C43.3734 39.5999 43.3675 39.0444 43.3566 38.4951Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7102 55.1832H47.7422C46.772 51.6612 46.1504 46.2409 46.1504 40.1616C46.1504 39.5999 46.1556 39.0444 46.166 38.4951H47.5663C47.5461 39.0444 47.5357 39.5999 47.5352 40.1616C47.5329 46.2409 48.7738 51.6612 50.7102 55.1832Z",
    fill: "#F8B805"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.06 35.1491H37.053C32.6775 35.132 29.3127 34.7982 26.4637 34.098C23.049 33.2585 20.3346 31.8721 18.1648 29.8587C13.5131 25.5431 11.3472 18.2984 11.3472 7.05867C11.3469 6.81699 11.3957 6.57777 11.4904 6.35543C11.5852 6.1331 11.724 5.93227 11.8985 5.76505C12.073 5.59783 12.2795 5.46769 12.5057 5.38248C12.7318 5.29727 12.9729 5.25876 13.2144 5.26927C13.3521 5.27549 27.0744 5.87689 36.9768 5.42487C37.2182 5.41436 37.4593 5.45287 37.6854 5.53808C37.9116 5.62329 38.1182 5.75343 38.2927 5.92065C38.4671 6.08787 38.6059 6.2887 38.7007 6.51103C38.7955 6.73337 38.8442 6.97259 38.844 7.21427V33.3597C38.844 33.8343 38.6554 34.2894 38.3199 34.625C37.9843 34.9605 37.5291 35.1491 37.0546 35.1491H37.06ZM14.9462 8.92042C15.1578 18.023 16.969 23.8681 20.5983 27.2353C23.5975 30.0182 28.0407 31.3361 35.2698 31.5423V9.0729C27.738 9.31642 18.7802 9.05734 14.9462 8.92042Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5739 7.2703C16.3575 7.26253 16.1419 7.29951 15.9405 7.37895C15.7391 7.45839 15.5563 7.57856 15.4035 7.73194C15.2507 7.88532 15.1312 8.0686 15.0525 8.2703C14.9739 8.472 14.9377 8.68777 14.9463 8.9041V8.92121C18.8114 9.05814 27.7763 9.31566 35.27 9.07681V7.36833C28.6609 7.5815 20.9525 7.40801 16.5739 7.2703Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2709 31.5411V31.1055C35.3074 31.326 35.3097 31.4759 35.2709 31.5411Z",
    fill: "#F8B805"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9464 8.90332L14.9869 8.92122H14.9464C15.158 18.0238 16.9692 23.8689 20.5986 27.2361C23.5977 30.019 28.0409 31.3369 35.2701 31.5431C34.7644 32.3989 31.8788 31.964 31.8788 31.964C12.3354 31.7197 14.9464 8.90332 14.9464 8.90332Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8015 33.6388V7.49265C38.8017 7.25097 38.753 7.01175 38.6582 6.78941C38.5635 6.56708 38.4246 6.36625 38.2502 6.19903C38.0757 6.03181 37.8691 5.90167 37.643 5.81646C37.4168 5.73125 37.1757 5.69274 36.9343 5.70325C27.0327 6.15682 13.3104 5.55543 13.1726 5.54765C12.7618 5.52934 12.3572 5.65309 12.0269 5.89808C11.6966 6.14307 11.4608 6.49435 11.3591 6.89281C11.4011 6.43475 11.6178 6.01043 11.9643 5.70795C12.3109 5.40546 12.7606 5.24803 13.2201 5.26835C13.3578 5.27457 27.0801 5.87597 36.9825 5.42395C37.2239 5.41344 37.465 5.45195 37.6912 5.53716C37.9173 5.62237 38.1239 5.75251 38.2984 5.91973C38.4729 6.08695 38.6117 6.28778 38.7064 6.51011C38.8012 6.73244 38.8499 6.97167 38.8497 7.21334V33.3595C38.8494 33.5085 38.8309 33.6569 38.7945 33.8014C38.7991 33.7478 38.8015 33.6933 38.8015 33.6388Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8587 34.4565C35.3126 34.4675 36.7647 34.5589 38.2085 34.7304C37.8867 35.0003 37.4802 35.1485 37.0602 35.1489H37.0532C32.6777 35.1318 29.3129 34.798 26.4638 34.0978C23.0492 33.2584 20.3348 31.872 18.1649 29.8585C15.7236 27.593 13.9637 24.5207 12.8489 20.4875C14.8234 26.4704 20.0461 34.2955 33.8587 34.4565Z",
    fill: "#F8B805"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.201 34.6271C51.0341 34.4609 50.9017 34.2634 50.8113 34.0459C50.721 33.8285 50.6744 33.5953 50.6743 33.3598V7.2128C50.6741 6.97112 50.7228 6.7319 50.8176 6.50957C50.9123 6.28724 51.0511 6.0864 51.2256 5.91919C51.4001 5.75197 51.6067 5.62183 51.8328 5.53662C52.059 5.45141 52.3001 5.4129 52.5415 5.42341C62.4439 5.87698 76.1662 5.27559 76.3039 5.26781C76.5454 5.2573 76.7864 5.29581 77.0126 5.38102C77.2388 5.46623 77.4453 5.59637 77.6198 5.76359C77.7943 5.9308 77.9331 6.13164 78.0279 6.35397C78.1226 6.5763 78.1713 6.81552 78.1711 7.0572C78.1711 18.2969 76.0052 25.5417 71.3535 29.8572C69.1837 31.8707 66.4692 33.2571 63.0546 34.0965C60.2056 34.7967 56.8407 35.1305 52.4653 35.1476H52.4583C51.987 35.1464 51.5352 34.9594 51.201 34.6271ZM54.2531 9.07299V31.5424C61.4823 31.3362 65.9231 30.0183 68.9254 27.2354C72.554 23.8682 74.3651 18.0231 74.5768 8.92051C70.7428 9.05743 61.7818 9.31651 54.2516 9.07299H54.2531Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2515 7.36829V9.07288C61.7451 9.31484 70.71 9.05732 74.5751 8.91728V8.90016C74.5837 8.6839 74.5476 8.4682 74.4689 8.26655C74.3903 8.06491 74.2709 7.88166 74.1182 7.7283C73.9655 7.57493 73.7828 7.45474 73.5815 7.37525C73.3802 7.29577 73.1646 7.2587 72.9483 7.26637C68.5697 7.40796 60.8613 7.58146 54.2515 7.36829Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2513 31.5411V31.1055C54.2148 31.326 54.2133 31.4759 54.2513 31.5411Z",
    fill: "#F8B805"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5755 8.90332L74.5351 8.92122H74.5747C74.3631 18.0238 72.5519 23.8689 68.9234 27.2361C65.9234 30.019 61.4803 31.3369 54.2511 31.5431C54.7568 32.3989 57.6424 31.964 57.6424 31.964C77.1857 31.7197 74.5755 8.90332 74.5755 8.90332Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7211 33.6388V7.49265C50.7209 7.25097 50.7696 7.01175 50.8643 6.78941C50.9591 6.56708 51.0979 6.36625 51.2724 6.19903C51.4469 6.03181 51.6534 5.90167 51.8796 5.81646C52.1058 5.73125 52.3468 5.69274 52.5883 5.70325C62.4899 6.15682 76.213 5.55543 76.3499 5.54765C76.7607 5.52934 77.1653 5.65309 77.4956 5.89808C77.8259 6.14307 78.0617 6.49435 78.1634 6.89281C78.1215 6.43475 77.9047 6.01043 77.5582 5.70795C77.2117 5.40546 76.762 5.24803 76.3024 5.26835C76.1647 5.27457 62.4424 5.87597 52.54 5.42395C52.2986 5.41344 52.0575 5.45195 51.8314 5.53716C51.6052 5.62237 51.3986 5.75251 51.2242 5.91973C51.0497 6.08695 50.9109 6.28778 50.8161 6.51011C50.7214 6.73244 50.6726 6.97167 50.6729 7.21334V33.3595C50.673 33.5086 50.6919 33.657 50.7289 33.8014C50.7235 33.7474 50.7209 33.6931 50.7211 33.6388Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6634 34.4567C54.2096 34.4666 52.7574 34.557 51.3136 34.7274C51.6354 34.9974 52.0419 35.1456 52.4619 35.146H52.4689C56.8444 35.1289 60.2092 34.7951 63.0583 34.0949C66.4729 33.2555 69.1873 31.8691 71.3572 29.8556C73.7985 27.5901 75.5584 24.5178 76.6732 20.4846C74.6963 26.4705 69.476 34.2956 55.6634 34.4567Z",
    fill: "#F8B805"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4948 0C23.9924 2.90344 23.7415 5.8448 23.7448 8.79138C23.7448 27.0642 33.1492 41.8773 44.7507 41.8773C56.3522 41.8773 65.7567 27.0642 65.7567 8.79138C65.76 5.8448 65.5091 2.90344 65.0067 0H24.4948Z",
    fill: "#F8B805"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4948 0C23.9924 2.90344 23.7415 5.8448 23.7448 8.79138C23.7448 27.0642 33.1492 41.8773 44.7507 41.8773C56.3522 41.8773 65.7567 27.0642 65.7567 8.79138C65.76 5.8448 65.5091 2.90344 65.0067 0H24.4948Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0068 0H57.4345C57.7493 2.91983 57.9051 5.85462 57.9013 8.79138C57.9013 27.0642 52.0126 41.8773 44.7477 41.8773C56.3492 41.8773 65.7536 27.0642 65.7536 8.79138C65.758 5.84489 65.5081 2.90353 65.0068 0Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0463 10.8428L47.7988 16.4202L53.9543 17.3149L49.5003 21.6569L50.5522 27.7876L45.0463 24.8926L39.5404 27.7876L40.5922 21.6569L36.1382 17.3149L42.2937 16.4202L45.0463 10.8428Z",
    fill: "#F7A108"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5958 8.79382C31.5919 5.85707 31.7478 2.92228 32.0626 0.00244141H26.8873C26.4432 2.91177 26.2218 5.85078 26.2253 8.79382C26.2276 27.0659 34.5195 41.8797 44.751 41.8797C37.486 41.8797 31.5958 27.0659 31.5958 8.79382Z",
    fill: "#F8B805"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.463 10.1373C31.9019 10.1373 33.879 8.16018 33.879 5.72134C33.879 3.28249 31.9019 1.30542 29.463 1.30542C27.0242 1.30542 25.0471 3.28249 25.0471 5.72134C25.0471 8.16018 27.0242 10.1373 29.463 10.1373Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8792 11.8877C34.8459 11.8877 35.6297 11.104 35.6297 10.1372C35.6297 9.17044 34.8459 8.38672 33.8792 8.38672C32.9124 8.38672 32.1287 9.17044 32.1287 10.1372C32.1287 11.104 32.9124 11.8877 33.8792 11.8877Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.46 0.65274C55.4858 0.65274 64.4242 0.360213 64.4242 0H24.495C24.495 0.360213 33.4334 0.65274 44.46 0.65274Z",
    fill: "#F8B805"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2468 55.1831H36.2763C35.7434 55.183 35.2158 55.2879 34.7234 55.4917C34.2311 55.6956 33.7837 55.9944 33.4069 56.3712C33.03 56.7479 32.7311 57.1952 32.5272 57.6875C32.3232 58.1798 32.2183 58.7075 32.2183 59.2404H57.304C57.304 58.7076 57.1991 58.18 56.9952 57.6877C56.7913 57.1955 56.4924 56.7482 56.1157 56.3715C55.7389 55.9947 55.2917 55.6958 54.7994 55.4919C54.3072 55.2881 53.7796 55.1831 53.2468 55.1831Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2763 55.4873H53.2468C54.2702 55.4872 55.2558 55.8739 56.0061 56.5699C56.7563 57.2659 57.2158 58.2198 57.2924 59.2404H57.3048C57.3048 58.1643 56.8773 57.1323 56.1165 56.3715C55.3556 55.6106 54.3236 55.1831 53.2475 55.1831H36.2763C35.7434 55.183 35.2158 55.2879 34.7234 55.4917C34.2311 55.6956 33.7837 55.9944 33.4069 56.3712C33.03 56.7479 32.7311 57.1952 32.5272 57.6875C32.3232 58.1798 32.2183 58.7075 32.2183 59.2404H32.2307C32.3074 58.2199 32.767 57.2661 33.5172 56.5701C34.2674 55.8741 35.2529 55.4874 36.2763 55.4873Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3035 59.2404H52.7654C52.7654 56.9997 51.6062 55.1831 50.1763 55.1831H53.2462C54.3223 55.1831 55.3543 55.6106 56.1152 56.3715C56.876 57.1323 57.3035 58.1643 57.3035 59.2404Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2862 55.1831H37.9408C37.408 55.183 36.8803 55.2879 36.388 55.4917C35.8956 55.6956 35.4483 55.9944 35.0714 56.3712C34.6946 56.7479 34.3957 57.1952 34.1917 57.6875C33.9878 58.1798 33.8828 58.7075 33.8828 59.2404H37.2329C37.2329 58.165 37.6598 57.1336 38.4198 56.3728C39.1799 55.6121 40.2109 55.1841 41.2862 55.1831Z",
    fill: "#F8B805"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8577 59.2405H25.6658C25.4583 59.2405 25.29 59.4087 25.29 59.6163V74.4519C25.29 74.6594 25.4583 74.8277 25.6658 74.8277H63.8577C64.0653 74.8277 64.2335 74.6594 64.2335 74.4519V59.6163C64.2335 59.4087 64.0653 59.2405 63.8577 59.2405Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8577 72.1482H25.6658C25.5661 72.1482 25.4706 72.1086 25.4001 72.0382C25.3296 71.9677 25.29 71.8721 25.29 71.7725V74.4519C25.29 74.5515 25.3296 74.6471 25.4001 74.7176C25.4706 74.7881 25.5661 74.8277 25.6658 74.8277H63.8577C63.907 74.8277 63.9559 74.8179 64.0014 74.799C64.047 74.7801 64.0883 74.7525 64.1232 74.7176C64.158 74.6826 64.1856 74.6412 64.2044 74.5956C64.2232 74.55 64.2328 74.5012 64.2327 74.4519V71.7725C64.2328 71.8218 64.2232 71.8706 64.2044 71.9162C64.1856 71.9618 64.158 72.0032 64.1232 72.0381C64.0883 72.073 64.047 72.1007 64.0014 72.1196C63.9559 72.1385 63.907 72.1482 63.8577 72.1482Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6657 74.8276H28.0168C27.1351 74.8276 26.2656 74.7929 25.4082 74.7234C25.4776 74.7898 25.5697 74.8271 25.6657 74.8276Z",
    fill: "#44352A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8579 59.2405H52.1817C50.3783 68.0661 40.2457 74.8277 28.0171 74.8277H63.8595C63.9088 74.8277 63.9576 74.8179 64.0032 74.7991C64.0487 74.7802 64.0901 74.7525 64.1249 74.7176C64.1597 74.6827 64.1873 74.6412 64.2061 74.5956C64.2249 74.5501 64.2346 74.5012 64.2345 74.4519V59.6163C64.2346 59.5668 64.2249 59.5178 64.206 59.4722C64.1871 59.4265 64.1594 59.385 64.1244 59.35C64.0894 59.3151 64.0478 59.2875 64.0021 59.2687C63.9563 59.2499 63.9074 59.2403 63.8579 59.2405Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8577 59.2405H25.6658C25.5661 59.2405 25.4706 59.2801 25.4001 59.3505C25.3296 59.421 25.29 59.5166 25.29 59.6163V60.1033C25.29 60.0036 25.3296 59.908 25.4001 59.8376C25.4706 59.7671 25.5661 59.7275 25.6658 59.7275H63.8577C63.907 59.7275 63.9559 59.7372 64.0014 59.7561C64.047 59.775 64.0883 59.8027 64.1232 59.8376C64.158 59.8725 64.1856 59.9139 64.2044 59.9595C64.2232 60.0051 64.2328 60.054 64.2327 60.1033V59.6163C64.2328 59.5669 64.2232 59.5181 64.2044 59.4725C64.1856 59.4269 64.158 59.3855 64.1232 59.3506C64.0883 59.3157 64.047 59.288 64.0014 59.2691C63.9559 59.2502 63.907 59.2405 63.8577 59.2405Z",
    fill: "#44352A"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7555 72.8181H22.7667C22.5055 72.8181 22.2937 73.0299 22.2937 73.2911V75.6329C22.2937 75.8942 22.5055 76.1059 22.7667 76.1059H66.7555C67.0168 76.1059 67.2285 75.8942 67.2285 75.6329V73.2911C67.2285 73.0299 67.0168 72.8181 66.7555 72.8181Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7555 75.681H22.7667C22.6413 75.681 22.521 75.6312 22.4322 75.5425C22.3435 75.4538 22.2937 75.3335 22.2937 75.208V75.6328C22.2937 75.7582 22.3435 75.8786 22.4322 75.9673C22.521 76.056 22.6413 76.1058 22.7667 76.1058H66.7555C66.881 76.1058 67.0013 76.056 67.09 75.9673C67.1787 75.8786 67.2285 75.7582 67.2285 75.6328V75.208C67.2285 75.3335 67.1787 75.4538 67.09 75.5425C67.0013 75.6312 66.881 75.681 66.7555 75.681Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7555 72.8181H22.7667C22.6413 72.8181 22.521 72.868 22.4322 72.9567C22.3435 73.0454 22.2937 73.1657 22.2937 73.2911V73.7292C22.2937 73.6037 22.3435 73.4834 22.4322 73.3947C22.521 73.306 22.6413 73.2561 22.7667 73.2561H66.7555C66.881 73.2561 67.0013 73.306 67.09 73.3947C67.1787 73.4834 67.2285 73.6037 67.2285 73.7292V73.2911C67.2285 73.1657 67.1787 73.0454 67.09 72.9567C67.0013 72.868 66.881 72.8181 66.7555 72.8181Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7555 72.8181H54.2126C54.3381 72.8181 54.4584 72.868 54.5471 72.9567C54.6358 73.0454 54.6857 73.1657 54.6857 73.2911V75.6329C54.6857 75.7584 54.6358 75.8787 54.5471 75.9674C54.4584 76.0561 54.3381 76.1059 54.2126 76.1059H66.7555C66.881 76.1059 67.0013 76.0561 67.09 75.9674C67.1787 75.8787 67.2286 75.7584 67.2286 75.6329V73.2911C67.2286 73.1657 67.1787 73.0454 67.09 72.9567C67.0013 72.868 66.881 72.8181 66.7555 72.8181Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7867 75.6329V73.2911C32.7867 73.1657 32.8365 73.0454 32.9253 72.9567C33.014 72.868 33.1343 72.8181 33.2597 72.8181H26.4359C26.3105 72.8181 26.1901 72.868 26.1014 72.9567C26.0127 73.0454 25.9629 73.1657 25.9629 73.2911V75.6329C25.9629 75.7584 26.0127 75.8787 26.1014 75.9674C26.1901 76.0561 26.3105 76.1059 26.4359 76.1059H33.2597C33.1343 76.1059 33.014 76.0561 32.9253 75.9674C32.8365 75.8787 32.7867 75.7584 32.7867 75.6329Z",
    fill: "#44352A"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7113 61.5396H28.7457V70.9572H60.7113V61.5396Z",
    fill: "#EFCA6F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7113 70.7563H28.7457V70.9571H60.7113V70.7563Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7113 61.5396H28.7457V61.7403H60.7113V61.5396Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2183 59.2406H57.304C57.304 58.9955 57.2816 58.751 57.2371 58.51H32.2859C32.2413 58.751 32.2186 58.9955 32.2183 59.2406Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5079 61.5396C50.0561 65.3206 47.0375 68.6014 43.0153 70.9572H60.7116V61.5396H51.5079Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0033 63.2557C30.3056 63.2557 30.5506 63.0107 30.5506 62.7084C30.5506 62.4062 30.3056 62.1611 30.0033 62.1611C29.7011 62.1611 29.4561 62.4062 29.4561 62.7084C29.4561 63.0107 29.7011 63.2557 30.0033 63.2557Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0405 62.7107C60.0397 62.6032 60.0072 62.4984 59.9469 62.4094C59.8866 62.3205 59.8014 62.2513 59.7019 62.2107C59.6024 62.1701 59.4931 62.1599 59.3878 62.1813C59.2825 62.2028 59.1859 62.2549 59.1102 62.3312C59.0345 62.4074 58.983 62.5044 58.9623 62.6098C58.9416 62.7153 58.9526 62.8245 58.9939 62.9237C59.0352 63.0229 59.105 63.1077 59.1944 63.1673C59.2838 63.2269 59.3888 63.2588 59.4963 63.2588C59.5681 63.2588 59.6392 63.2446 59.7055 63.217C59.7717 63.1894 59.8319 63.1489 59.8825 63.098C59.9331 63.0471 59.9731 62.9866 60.0002 62.9201C60.0273 62.8537 60.041 62.7825 60.0405 62.7107Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4932 70.3267C59.7955 70.3267 60.0405 70.0817 60.0405 69.7795C60.0405 69.4772 59.7955 69.2322 59.4932 69.2322C59.1909 69.2322 58.9459 69.4772 58.9459 69.7795C58.9459 70.0817 59.1909 70.3267 59.4932 70.3267Z",
    fill: "#EFCA6F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9627 63.1974C30.2649 63.1974 30.51 62.9523 30.51 62.6501C30.51 62.3478 30.2649 62.1028 29.9627 62.1028C29.6604 62.1028 29.4154 62.3478 29.4154 62.6501C29.4154 62.9523 29.6604 63.1974 29.9627 63.1974Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0033 70.3206C30.3056 70.3206 30.5506 70.0756 30.5506 69.7734C30.5506 69.4711 30.3056 69.2261 30.0033 69.2261C29.7011 69.2261 29.4561 69.4711 29.4561 69.7734C29.4561 70.0756 29.7011 70.3206 30.0033 70.3206Z",
    fill: "#EFCA6F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9627 70.2601C30.2649 70.2601 30.51 70.0151 30.51 69.7128C30.51 69.4106 30.2649 69.1655 29.9627 69.1655C29.6604 69.1655 29.4154 69.4106 29.4154 69.7128C29.4154 70.0151 29.6604 70.2601 29.9627 70.2601Z",
    fill: "#44352A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4932 63.1974C59.7955 63.1974 60.0405 62.9523 60.0405 62.6501C60.0405 62.3478 59.7955 62.1028 59.4932 62.1028C59.1909 62.1028 58.9459 62.3478 58.9459 62.6501C58.9459 62.9523 59.1909 63.1974 59.4932 63.1974Z",
    fill: "#44352A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4932 70.2601C59.7955 70.2601 60.0405 70.0151 60.0405 69.7128C60.0405 69.4106 59.7955 69.1655 59.4932 69.1655C59.1909 69.1655 58.9459 69.4106 58.9459 69.7128C58.9459 70.0151 59.1909 70.2601 59.4932 70.2601Z",
    fill: "#44352A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckForPrizes);
export default __webpack_public_path__ + "static/media/checkForPrizes.9c31e541dd8d7c0aa7e49dc3a24a508f.svg";
export { ForwardRef as ReactComponent };